module.exports = __webpack_public_path__ + "img/horizontal_3_7_4.e1ccfaf1.png";